export default __webpack_public_path__ + "static/media/record.95247ae6.svg";